export default __webpack_public_path__ + "fd64474e3368ef87bf715419de174bfd.woff2";